<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9wP1IN/images/9781940396330_cover.jpg?1684514526152" alt="This image is the cover for the book What Are Intellectuals Good For?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Are Intellectuals Good For?
      </h1>
      <p class="bookDescription body article font2">
        <p>Essays and reviews concentrating on politics, economics, sociology and culture. When George’s What Are Intellectuals Good For? appeared it was greeted by an NPR review that sang the book’s praises. Pressed Wafer was totally unprepared for the blizzard of orders that came from Amazon. We hustled out and purchased the George Scialabba Two Wheeler to cart the books to the Post Office! The current cliché is that America has no public intellectuals. Every sentence George writes gives the lie to this bit of lazy journalese.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Scialabba
      </h2>
      
      <p class="authorDescription body article">George Scialabba is a freelance book critic, a contributing editor of The Baffer, and the author of Divided Mind (2006), The Modern Predicament (2011), For The Republic (2013) and Low Dishonest Decades (2016)). He lives in Cambridge, Massachusetts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pressed Wafer
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af487ea0